import {HttpClient, HttpHeaders}            from "@angular/common/http";
import {Injectable}                         from '@angular/core';

import {AngularQuery}                       from "../query/angularquery";
import {Vendor}                             from "./vendor";
import {VendorLink}                         from "./vendor-link";

import {map}                                from "rxjs/operators";
import {Observable}                         from "rxjs";

@Injectable()
export class VendorService {

	/**
	 * Initialize the object.
	 *
	 * @param {HttpClient} http  The Http Service.
	 */
	constructor(protected http: HttpClient) {}


	/**
	 * Delete the vendor associated with the specified ID number.
	 *
	 * @param {number} id  The ID of the Vendor to delete.
	 * @returns {Observable<Boolean>} Whether the delete was successful or not.
	 */
	deleteVendor(id:number): Observable<Boolean> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_VENDOR, id.toString());
		query.useParams(false);
		query.useCacheBuster(false);
		let url:string = query.getUrl();

		return this.http
			.delete<Boolean>(url)
			.pipe(
				map(() => true)
			);

	}


	/**
	 * Get all the vendor data associated with the
	 * provided Player ID.
	 *
	 * @param id              A Player ID to retrieve data for.
	 * @returns {Observable<VendorLink[]>}  Vendor data.
	 */
	getPlayerVendorData(id: number): Observable<VendorLink[]> {

		if (-1 === id) {

			return Observable.of([]).delay(500);

		}

		let argument:string = id.toString() + '/vendor/';
		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_PLAYER, argument);

		return this.getVendorData(query);

	}


	/**
	 * Get all the vendor data associated with the
	 * provided Team ID.
	 *
	 * @param id              A Team ID to retrieve data for.
	 * @returns {Observable<VendorLink[]>}  Vendor data.
	 */
	getTeamVendorData(id: number): Observable<VendorLink[]> {

		if (-1 === id) {

			return Observable.of([]).delay(500);

		}

		let argument:string = id.toString() + '/vendor/';
		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_TEAM, argument);
		query.useParams(false);
		query.useCacheBuster(false);

		return this.getVendorData(query);

	}


	/**
	 * Perform the AngularQuery for team or player vendor data
	 * and return it as an Observable.
	 *
	 * @param query               The query as formatted in getTeamVendorData or getPlayerVendorData.
	 * @returns {Observable<VendorLink[]>}   The Observable to return.
	 */
	private getVendorData(query: AngularQuery): Observable<VendorLink[]> {

		let url:string = query.getUrl();

		return this.http
			.get<VendorLink[]>(url);

	}


	/**
	 * Get a list of the Vendors and their identifiers.
	 *
	 * @returns {Observable<Vendor[]>}  The array of Vendor objects.
	 */
	getVendors(): Observable<Vendor[]> {

		let query:AngularQuery = new AngularQuery();
		query.setEndpoint(AngularQuery.ENDPOINT_VENDOR);

		return this.http
			.get<Vendor[]>(query.getUrl());

	}


	/**
	 * Save the provided vendor information.
	 *
	 * @param {string} url    The URL to post to.
	 * @param {string} json   The data as a JSON string.
	 * @return {Observable<Vendor>}  The saved Vendor data echoed back.
	 */
	save(url: string, json: string): Observable<Vendor> {

		// Warn them that JSON is coming.
		let headers = new HttpHeaders().append('Content-Type', 'application/json');
		return this.http
			.post<Vendor>(url, json, { headers: headers });

	}


}



// WEBPACK FOOTER //
// ./src/app/services/vendor/vendor.service.ts